module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAC5SURBVEhL7ZHRCcJAEEQP8m8NtpFWtIs0oMXYirZhDf4LZgaycKw73m3yJ3nwOG7ZmYSk7GzhBD+dcjfFEb5gVBbJXWa6GOAdMviG03L6Ui8zzDa5QAtdOVjOukzJ7E9GaG/7gPZGPHn3hV5m2RFygE/Ixeib9v4XdrDrixu0pTMHAZzXZUp2hdjCWpr5/3uA3bNziQpk5xIVyM4lKpCdS1TAzxXNPb9gdz9XNPfqsi1KouU17vRSygyuaMcQuPoLygAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-house/dark/24.png
// module id = 2158
// module chunks = 2